import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { ALLOWANCES } from 'mobile/constants';
import { createOfferCurrency as currency } from 'common/oldJavascripts/utils/format';

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: 60,
  },
  noAllowance: {
    fontSize: '18px',
    color: '#999999',
    textAlign: 'center',
  },
  title: {
    color: '#646464',
    fontSize: '24px',
    fontWeight: 400,
    marginBottom: 18,
  },
  name: {
    color: '#5b5b5b',
    fontSize: 16,
    fontWeight: 500,
  },
  perDay: {
    color: '#30aba3',
    fontSize: 12,
    fontWeight: 400,
    position: 'relative',
    bottom: '9px',
  },
  capTitle: {
    color: '#5b5b5b',
    fontSize: 12,
    fontWeight: 500,
  },
  smallCapAmount: {
    color: '#5b5b5b',
    fontSize: 12,
    fontWeight: 700,
  },
  amount: {
    color: '#2eaba4',
    fontSize: 30,
    fontWeight: 400,
    wordWrap: 'break-word',
  },
  allowances: {
    backgroundColor: '#f5fcfb',
    padding: 20,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: '10px',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
    '& div': {
      padding: 5,
      [theme.breakpoints.down('md')]: {
        marginBottom: 20,
      },
    },
  },
}));

const formatAmount = amount => {
  return !Number.isInteger(amount) ? currency(amount) : `$${amount}`;
};

const Allowances = props => {
  const classes = useStyles();
  const { terms_of_employment: terms = [] } = props?.offerData;
  const isEmptyAllowance = ALLOWANCES.every(
    ({ key }) => !terms[`${key}_amount`],
  );

  if (isEmptyAllowance) return null;

  return (
    <div className={classes.container}>
      <Typography className={classes.title}>Allowances</Typography>
      <div className={classes.allowances}>
        {ALLOWANCES.map(({ key, title }) => {
          const amount = terms[key + '_amount'];
          const perDay = terms[key + '_per'];
          const duration = terms[key + '_duration'] || 'Run of Show';
          const cap = terms[key + '_cap'];
          if (!amount) return null;
          return (
            <div>
              <Typography className={classes.name}>{title}</Typography>
              <Typography className={classes.amount}>
                {formatAmount(amount)}
              </Typography>
              <Typography className={classes.perDay}>per {perDay}</Typography>

              <Typography className={classes.capTitle}>
                Cap: {formatAmount(cap)}
              </Typography>
              <Typography className={classes.capTitle}>
                Duration:{' '}
                <span className={classes.smallCapAmount}>{duration}</span>
              </Typography>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Allowances;
